//import { params } from "@nuxtjs/svg-sprite/lib/plugins/inlineDefs";


(function($) {
    const GiuliaWebSite = {
        isMobile() {
            return $(window).width() < 1024 ? true : false;
        },
        helpers: {
            prepareDataParams(data) {
                for(let item in data) {
                    if(['mask', 'min', 'max', 'minDate', 'maxDate'].indexOf(item) !== -1) {
                        if(item == 'mask') {
                            if(['Date', 'Number'].indexOf(data[item]) !== -1) {
                                data[item] = eval(data[item]);
                            }
                        } else {
                            data[item] = eval(data[item]);
                        }
                        
                    }
                }
                return data;
            },

            getOffset(el) {
                var _x = 0;
                var _y = 0;
                while( el && !isNaN( el.offsetLeft ) && !isNaN( el.offsetTop ) ) {
                    _x += el.offsetLeft - el.scrollLeft;
                    _y += el.offsetTop - el.scrollTop;
                    el = el.offsetParent;
                }
                return { top: _y, left: _x };
            },
    
            scrollTo(to, duration = 500) {
                to = this.getOffset(document.querySelector(to)).top;
                var start = document.documentElement.scrollTop,
                    change = to - start,
                    currentTime = 0,
                    increment = 20;
                var animateScroll = function() {        
                    currentTime += increment;
                    var val = Math.easeInOutQuad(currentTime, start, change, duration);
                    document.documentElement.scrollTop = val - 150;
                    if(currentTime < duration) {
                        setTimeout(animateScroll, increment);
                    }
                };
                animateScroll();
            }
        },

        header: {
            topMenu() {
                let $currentMenu = null;
                $(".main-menu-holder").on("mouseenter", function() {

                    
                    const $holder = $(this);

                    if($currentMenu) {
                        $currentMenu.removeClass("active");
                    }
                
                    
                    if($holder.find(".main-menu-sub").length) {

                        
                        $holder.addClass("active");
                        $currentMenu = $holder;

                        if(GiuliaWebSite.header.nav.isOpen)
                        {
                            GiuliaWebSite.header.nav.toggle();
                        }
                    }

                   
                  
                });

                $("#page-header").on("mouseleave", function() {

                    const $holder = $(this);
                    if($currentMenu) {
                        $currentMenu.removeClass("active");
                    }

                });

                if($("#page").hasClass("header-transparent")) {
                    $("#page-header").on("mouseenter", function() {
                        //$("#page").addClass("show-nav");
                    }).on("mouseleave", function() {
                        if($(".main-menu-holder.active, #page-nav.show").length == 0) {
                            $("#page").removeClass("show-nav");
                        }
                    });
                }
            },
            nav: {
                isOpen: false,
                $block: null,
                $overlay: null,
                init() {
                    let self = this;

                    self.$block = $("#page-nav");
                    $('#page').append('<div class="page-nav-overlay" id="page-nav-overlay"></div>');
                    self.$overlay = $("#page-nav-overlay");

                    $('[data-action="open-nav"]').on("click", function(e) {
                       
                        e.preventDefault();
                        e.stopPropagation();
                        self.toggle();
                        
                    });

                    self.$overlay.on("click", function() {
                    
                        self.toggle();
                    });
                },
                toggle($btn) {
                    let self = this;
                    //console.log(self.isOpen);
                    self.isOpen ? self.hide() : self.show();
                    self.changeTitle();
                    $("#page-header").toggleClass("open-menu");
                },
                show() {
                    let self = this;

                    GiuliaWebSite.scrollHeader.hold();

                    self.$overlay.show();
                    self.$block.css('display', 'block');
                    $('#page').addClass('show-nav');
                    setTimeout(() => self.$block.addClass('show'), 50);
                    self.isOpen = true;

                    if(GiuliaWebSite.isMobile()) {
                        //bodyScrollLock.disableBodyScroll(self.$block[0]);
                        $("body").css({"overflow": 'hidden'});
                    }
                    
                    
                },
                hide() {
                    let self = this;

                    self.$overlay.hide();
                    self.$block.removeClass('show');
                    self.$block.css('display', 'none');
                    self.isOpen = false;
                    $('#page').removeClass('show-nav');

                    //bodyScrollLock.enableBodyScroll(self.$block[0]);
                    $("body").css({"overflow": 'auto'});
                    GiuliaWebSite.scrollHeader.release();
                },
                changeTitle() {
                    let self = this;

                    $('[data-action="open-nav"]').each(function() {
                        const $btn = $(this);
                        if($btn.data('closetitle') && $btn.data('opentitle')) {
                            self.isOpen ? $btn.html($btn.data('closetitle')) : $btn.html($btn.data('opentitle'));
                        }
                    });
                }
            },
            init() {
                this.topMenu();
                this.nav.init();
            }
        },

        aside: {
            isOpen: false,
            $block: null,
            $content: null,
            $overlay: null,
            $close: null,
            $currentBtn: null,
            init() {
                let self = this;

                self.$block = $("#page-aside");
                $('#page').append('<div class="page-aside-overlay" id="page-aside-overlay"></div>');
                self.$overlay = $("#page-aside-overlay");
                self.$close = $("#page-aside-close");
                self.$content = $("#page-aside-content");

                $('[data-aside]').on("click", function(e) {
                    self.$currentBtn = $(this);
                    e.preventDefault();
                    e.stopPropagation();
                    self.toggle();
                });
              

                $('[data-aside-form]').on("click", function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    const fixedSelector = '#form_vue_design.base';
                    const $fixedForm = $(fixedSelector);
                    if($fixedForm.length) {
                        GiuliaWebSite.helpers.scrollTo(fixedSelector);
                        return false;
                    }
                    const formSelector = $(this).data('aside-form');
                    if(formSelector) {
                        const $target = $(formSelector);
                        if($target.length && $target.closest('#page-aside').length) {
                            GiuliaWebSite.helpers.scrollTo(formSelector);
                            return false;
                        }
                    }
                    $(".page-aside-overlay").show();
                    $(".form-ajax #page-aside").toggleClass("show");
                    return false;
                });

                self.$overlay.on("click", function() {
                    self.toggle();
                });

                self.$close.on("click", function() {
                    self.toggle();
                });

                
              
            },
            toggle($btn) {
                let self = this;
                //console.log($(this));
                
                self.isOpen ? self.hide() : self.show();
            },
            async show(url) {
                let self = this;

                var html = "";
                
                if(url)
                {
                     html =  $(url).html();
                     //console.log(html);
                }
                else{
 
                 html = $(self.$currentBtn.data('aside')).html();//await self.load(url ? url : self.$currentBtn.data('aside'));
                }

                //console.log(html);
                self.$content.empty().html(html);

                self.$overlay.show();
                self.$block.addClass('show');
                self.isOpen = true;
                
            },
            hide() {
                let self = this;

                self.$overlay.hide();
                self.$block.removeClass('show');
                self.isOpen = false;
            },
            async load(url) {
                let urlObj = new URL(window.location.origin + url);
                urlObj.searchParams.append('IS_AJAX', 'Y');
                let response = await fetch(urlObj.toString());
                if(response.ok) {
                    let html = await response.text();
                    return html;
                }
            }
        },

        popups: {
            params: {
                type: "ajax",
                mainClass: "mfp-fade",
                removalDelay: 300,
                tClose: "Закрыть (ESC)",
                tLoading: "Загрузка...",
                closeBtnInside: false,
                callbacks: {
                    ajaxContentAdded: function() {
                    },
                    open: function() {
                    },
                    beforeOpen: function() {
                        if(this.st.link) {
                            $(this.container).append(`<a class="page-popup-link" href="${this.st.link.href}">${this.st.link.title}</a>`);
                        }
                    }
                },
                fixedContentPos: true,
                overflowY: "scroll"
            },
            init: function($container) {
                var self = this;

                if(!$container) {
                    var $container = $("body");
                }
                $("[data-popup]", $container).each(function() {
                    (function($p) {
                        var params = $p.data("popup");
                        $p.magnificPopup($.extend({}, self.params, params));
                    })($(this));
                });

                $("body").on("click", ".popup-close", function(e) {
                    e.preventDefault();
                    $.magnificPopup.close();
                });
            }
        },

        tips() {
            tippy('[data-tip]', {
                content(reference) {
                    const template = document.getElementById(reference.getAttribute('data-tip'));
                    return template.innerHTML;
                },
                appendTo: () => document.body,
                allowHTML: true,
                arrow: false,
                placement: 'top',
                interactive: true,
                maxWidth: 280,
                offset: [0, 25],
                hideOnClick: false,
                
            });
        },

        slider(sliders, params = {}) {
            [...sliders].forEach(function(slider) {
                new Swiper(slider, {
                    // Optional parameters
                    direction: 'horizontal',
                    loop: true,
                  
                    // If we need pagination
                    pagination: {
                      el: '.swiper-pagination',
                    },
                  
                    // Navigation arrows
                    navigation: {
                      nextEl: '.swiper-button-next',
                      prevEl: '.swiper-button-prev',
                    },
                  
                    // And if we need scrollbar
                    scrollbar: {
                      el: '.swiper-scrollbar',
                    },
                    speed: 500,
                    // Disable preloading of all images
                    //preloadImages: false,
                    // Enable lazy loading
                    lazy: { enabled:true,
                        loadPrevNext: true,
                        loadPrevNextAmount:1},
                   
                });
            });
        },

        forms: {
            customize() {
                $(".form-file").each(function() {
                    (function($input) {
                        $input.on("change", function() {
                            if(this.files && this.files[0]) {
                                $input.next('span').text(this.files[0].name);
                            }
                        });
                    })($(this).find("input"));
                });
            },
            mask() {
                $('[data-mask]').each(function() {
                    let $m = $(this),
                        datas = RingsWebSite.helpers.prepareDataParams($m.data('mask'));
                    IMask($m[0], Object.assign({}, {
                        radix: '.',
                        //lazy: false
                    }, datas));
                });
            },
            validation() {
                $('form.form').each(function() {
                    const formValidation = new JustValidate(this);
                    $('[data-validation]', $(this)).each(function() {
                        let $v = $(this),
                            datas = $v.data("validation");
                        if(!$v.attr("id")) {
                            $v.attr("id", "ff_" + Math.round(Math.random() * 1000));
                        }
                        formValidation.addField('#' + $v.attr("id"), datas);
                    });
                });
                $('[data-mask]').each(function() {
                    let $m = $(this),
                        datas = RingsWebSite.helpers.prepareDataParams($m.data('mask'));
                    IMask($m[0], Object.assign({}, {
                        radix: '.',
                        //lazy: false
                    }, datas));
                });
            }
        },

        anchors: {
            selector: '[data-scrollTo]',
            init() {
                $(this.selector).on('click', function(e) {

       
                    e.preventDefault();
                    e.stopPropagation();
                    GiuliaWebSite.helpers.scrollTo($(this).data('scrollto'));
                });
            }
        },

        contacts: {
            init() {
                $('a[href^="mailto:"]').on("click", function() {
                    ym(49951, 'reachGoal', 'allpost');
                });

                $('a[href^="tel:"]').on("click", function() {
                    ym(49951, 'reachGoal', 'allphone');
                });

                $('a[href*=".pdf"]').on("click", function() {
                    ym(49951, 'reachGoal', 'buklet');
                });

                $('.footer-socials a[target="_blank"]').on("click", function() {
                    ym(49951, 'reachGoal', 'social');
                });

                $('a[href^="http"]').on("click", function() {
                    if(new URL(this.href).hostname !== window.location.hostname) {
                        ym(49951, 'reachGoal', 'allsite');
                    }
                });
            }
        },

        content: {
            init() {
                $(".show-facades").on("click", function(e) {
                    e.preventDefault();
                    $(this).parent().addClass("d-none").siblings('.d-none').removeClass("d-none");
                });

                if($("#page-top").length) {
                    $(window).on("scroll", function() {
                        $(this).scrollTop() > 2000 ? $("#page-top").addClass("show") : $("#page-top").removeClass("show");
                    });
                }
            }
        },

        expand: {
            selector: '[data-expand]',
            init() {
                $(this.selector).each(function() {
                    
                    (function($item) {
                        $item.find('.expand-item-heading').on('click', function(e) {
                            e.preventDefault();
                            e.stopPropagation();
                            $item.toggleClass('open');
                        })
                    })($(this));
                });
            }
        },

        video: {
            selector: '[data-video]',
            init() {
                var self = this;

                $(this.selector).each(function() {
                    (($block) => {
                        $block.append('<iframe frameborder="0" width="560" height="315" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen="allowfullscreen" class="img-cover"></iframe>')
                        $block.find(".video-play").on("click", function() {
                            $block.addClass("play");
                            $block.find("iframe")[0].src = `https://www.youtube.com/embed/${$block.data("video")}?autoplay=1`;
                        });
                    })($(this));
                });
            }
        },

        comments: {
            selector: '.comment',
            moreSelector: '.comment-more',
            toggleSelector: '.comment-toggle',
            init() {
                var self = this;
                $(self.selector).each(function() {
                    (($block) => {
                        $block.find(self.toggleSelector).on("click", function(e) {
                            e.preventDefault();
                            $(this).toggleClass('toggle');
                            $block.find(self.moreSelector).fadeToggle();
                        });
                    })($(this));
                });
            }
        },

        tabs: {
            selector: '[data-tab]',
            init() {
                $(this.selector).each(function() {
                    (function($heading, params) {
                        $heading.on("click", function(e) {
                            e.preventDefault();
                            e.stopPropagation();

                            if(params.tabs) {
                                $(params.tabs).removeClass(params.activeTabClass).addClass(params.unActiveTabClass);
                                $(`${params.tabs}-heading`).removeClass(params.activeHeadingClass).addClass(params.unActiveHeadingClass);
                            }

                            const $tab = $(params.dest);
                            $tab.removeClass(params.unActiveTabClass).addClass(params.activeTabClass);
                            $heading.removeClass(params.unActiveHeadingClass).addClass(params.activeHeadingClass);
                        });
                    })($(this), $(this).data('tab'));
                });
            }
        },

        maps: {
            selector: '[data-map]',
            init() {
                $(this.selector).each(function() {
                    (function($map) {
                        const params = $map.data('map');
                        let map = new ymaps.Map($map[0], {
                            center: params.center,
                            zoom: params.zoom
                        });
                        map.behaviors.disable('scrollZoom');
                        if(params.points) {
                            for(let i = 0; i < params.points.length; i++) {
                                (function(point, map) {
                                    let mapPoint = new ymaps.Placemark(
                                        point.coords,
                                        {
                                            id: point.id
                                        }, {
                                            iconLayout: 'default#image',
                                            iconImageHref: params.pointIcon,
                                            iconImageSize: params.pointIconSize,
                                            iconImageOffset: params.pointIconOffset
                                        }
                                    );
                                    map.geoObjects.add(mapPoint);
                                    mapPoint.events.add('click', function(e) {
                                        GiuliaWebSite.aside.show(`/map_point_info.html?id=${mapPoint.properties.get('id')}`);
                                    });

                                    const paramsFromUrl = new URLSearchParams(window.location.search);
                                    if(paramsFromUrl.get('id') && paramsFromUrl.get('id') == point.id) {
                                        GiuliaWebSite.aside.show(`/map_point_info.html?id=${mapPoint.properties.get('id')}`);
                                    }
                                })(params.points[i], map);
                            }
                        }
                    })($(this));
                });
            }
        },
        getRootUrl() {
            var scripts = document.getElementsByTagName('script' ),
                script = scripts[scripts.length - 1],
                path = script.getAttribute( 'src' ).split( '/' ),
                pathname = location.pathname.split( '/' ),
                notSame = false,
                same = 0;
    
            for ( var i in path ) {
                if ( !notSame ) {
                    if ( path[i] == pathname[i] ) {
                        same++;
                    } else {
                        notSame = true;
                    }
                }
            }
            return location.origin + pathname.slice( 0, same ).join( '/' );
        },

        scrolled: 
        {
            init()
            {
                var element = document.querySelector('.full-scroll');
                //console.log(element);

                if(element !== null)
                {
                    let scrolled = this;
                    //console.log("mov");
                    // Добавить класс "element" при наведении на элемент
                    element.addEventListener('mouseenter', function() {
                        
                        //console.log("mov");
                            element.addEventListener('wheel', scrolled.handleWheel.bind(null, element), false);
    
                    });
    
                    element.addEventListener('mouseleave', function() {
    
                        //console.log("leave");
                        element.removeEventListener('wheel', scrolled.handleWheel);
                     //element.classList.remove('element');
    
                    });
                }
             
            },

            handleWheel: function(element) {

                // console.log(event);
                //console.log(element);
                // console.log(el);
                    // Если нажата клавиша Shift при прокрутке колесика мыши
                    //let element = event.target;
                    //if (event.shiftKey) {
                        // Отменяем вертикальную прокрутку
                        event.preventDefault();
            
                        if($(element).hasClass("horizontal"))
                        {
                            // Прокручиваем горизонтально
                            element.scrollLeft += event.deltaY;
                        }
                        else
                        {
                            //console.log(event.deltaY);


                            // Прокручиваем вертикально
                            if(event.deltaY > 0)
                            {
                                element.scrollTop += event.deltaY - 100;
                            }
                            else
                            {
                                element.scrollTop += event.deltaY + 100;
                            }

                            
                        }
                      


                    //}
            },


        },


        setCookie(name, value, options = {}) {

                options = {
                path: '/',
                // при необходимости добавьте другие значения по умолчанию
                ...options
                };
        
                if (options.expires instanceof Date) {
                options.expires = options.expires.toUTCString();
                }
        
                let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);
        
                for (let optionKey in options) {
                updatedCookie += "; " + optionKey;
                let optionValue = options[optionKey];
                if (optionValue !== true) {
                    updatedCookie += "=" + optionValue;
                }
                }
        
                document.cookie = updatedCookie;
        },
    
        deleteCookie(name) {
            setCookie(name, "", {
            'max-age': -1
            })
        },

        init() {
            let self = this;

            this.header.init();
            this.aside.init();
            this.forms.customize();
            this.anchors.init();
            this.tabs.init();


            let query = window.location;
            let qs = new URL(query);

            //console.log(qs.searchParams.get('form'));

            if(qs.searchParams.get('form') == "start")
            {

                $(".page-aside-overlay").show();
                $(".form-ajax #page-aside").toggleClass("show");

                
            }   

            this.expand.init();

            this.video.init();
            //this.comments.init();
            //this.scrolled.init();
            $('.has-popup').each(function() {
                new MenuPopup($(this));
            });
            // ymaps.ready(function() {
            //     self.maps.init();
            // });

            $('[data-popover]').each(function() {
                new BottomPopover($(this), $($(this).data("popover")));
            });

            this.contacts.init();

            this.content.init();

            this.scrollHeader = new ScrollHeader($("#page-header"));

            $.fancybox.defaults.animationEffect = 'fade';
            $.fancybox.defaults.thumbs = false;
            $.fancybox.defaults.toolbar = true;
            $.fancybox.defaults.slideShow = false;
            $.fancybox.defaults.infobar = false;
            $.fancybox.defaults.loop = true;

            $.fancybox.defaults.baseClass = 'page-popup-gallery';

            $.fancybox.defaults.btnTpl =  {
                close: `
                    <button data-fancybox-close class="page-popup-gallery-close">
                        <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M5.20703 5.20703L19.7904 19.7904M5.20703 19.7904L19.7904 5.20703" stroke="#1D1D1D" stroke-width="1.5" stroke-linecap="round"/>
                        </svg>
                    </button>
                `,
                arrowLeft: `
                    <button data-fancybox-prev class="page-popup-gallery-nav page-popup-gallery-nav--left">
                        <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M28 33L21 25.5L28 18" stroke="#1D1D1D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </button>
                `,
                arrowRight: `
                    <button data-fancybox-next class="page-popup-gallery-nav page-popup-gallery-nav--right">
                        <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M22 17L29 24.5L22 32" stroke="#1D1D1D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </button>
                `,
                zoom: `
                    <button data-fancybox-zoom class="page-popup-gallery-zoom">
                        <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M19 11.5C19 15.6421 15.6421 19 11.5 19C7.35786 19 4 15.6421 4 11.5C4 7.35786 7.35786 4 11.5 4C15.6421 4 19 7.35786 19 11.5ZM17.2275 17.7806C15.7166 19.1593 13.7065 20 11.5 20C6.80558 20 3 16.1944 3 11.5C3 6.80558 6.80558 3 11.5 3C16.1944 3 20 6.80558 20 11.5C20 13.6282 19.2179 15.5736 17.9254 17.0647L22.4588 21.716C22.6515 21.9137 22.6537 22.2365 22.4637 22.437C22.2737 22.6375 21.9634 22.6398 21.7707 22.4421L17.2275 17.7806Z" fill="#1D1D1D"/>
                        </svg>
                    </button>
                `
            };

            $.fancybox.defaults.beforeShow = function(){ 

                
                if($(this)[0].contentType == "video")
                {

                    $(".fancybox-navigation").hide();
                    //console.log("test");
                }
            };

            // {
            //     baseClass: 'page-popup-gallery',
                
            // }
            $('[data-fancybox*="gallery"]').fancybox();
        }
    };

    Math.easeInOutQuad = function (t, b, c, d) {
        t /= d/2;
        if (t < 1) return c/2*t*t + b;
        t--;
        return -c/2 * (t*(t-2) - 1) + b;
    };

    window.GiuliaWebSite = GiuliaWebSite;



    let openedMenu = null;

    $(document).on("click", function(e) {
        const $target = $(e.target);
        if(openedMenu && !$target.hasClass('is-popup') && !$target.closest('.is-popup').length && !$target.hasClass('is-popup') && !$target.closest('.is-popup').length) {
            openedMenu.hide();
        }

        if($(".main-menu-holder.active").length && !$target.closest('.main-menu-holder.active').length && !$target.hasClass('main-menu-sub') && !$target.closest('.main-menu-sub').length) {
            $(".main-menu-holder.active").removeClass("active");
            $("#page").removeClass("show-nav");
        }
    });


    // $(".header-logo").mouseenter(function(){


    //     $(".red-logo").show();
    //     $(".red-logo").show();

    // });

    // $(".header-logo").mouseleave(function(){

    //     $(".red-logo").hide();
    // });

    class MenuPopup {
        constructor($item) {
            this.$item = $item;
            this.$sub = $item.siblings('.is-popup');
            this.showTimer = null;
            this.hideTimer = null;
            this.outTimer = null;
            this.isShow = false;
            this.canHide = false;
            this.params = $item.data("menupopup") ? $item.data("menupopup") : {};

            this.build();
            this.handle();
        }
        build() {
            this.$sub.appendTo($('body'));
        }
        handle() {
            const self = this;
            this.$item.on("click", function(e) {
                e.preventDefault();
                e.stopPropagation();
            });
            this.$item.on("mouseenter", function() {
                if(self.hideTimer) {
                    clearTimeout(self.hideTimer);
                }
                clearTimeout(self.outTimer);
                setTimeout(function() {
                    self.canHide = true;
                }, 500);
                self.show();
            }).on("mouseleave", function() {
                //console.log("start timer form item");
                self.outTimer = setTimeout(function() {
                    self.hide();
                }, 500);
            });
            this.$sub.on("mouseenter", function() {
                clearTimeout(self.outTimer);
               // console.log("stop timer");
            }).on("mouseleave", function() {
               // console.log("start timer form sub");
                self.outTimer = setTimeout(function() {
                    self.hide();
                }, 500);
            });
        }
        show() {
            if(openedMenu && openedMenu != this) {
                openedMenu.hide();
            }

            const self = this;
            this.$item.addClass('active');
            this.$sub.css(self.setPosition()).show();
            this.isShow = true;
            this.showTimer = setTimeout(function() {
                self.$sub.addClass("show");
            }, 50);

            openedMenu = self;
        }
        setPosition() {
            const itemPos = this.$item.offset(),
                itemHeight = this.$item.height(),
                itemWidth = this.$item.width(),
                subWidth = this.$sub.width(),
                windowWidth = $(window).width();
            if(itemPos.left + subWidth >= windowWidth) {
                return {
                    top: itemPos.top + itemHeight,
                    right: 10,
                    left: 'auto'
                }
            } else {
                if(this.params.rightPos) {
                    return {
                        top: itemPos.top + itemHeight,
                        right: windowWidth - itemPos.left - itemWidth,
                        left: 'auto'
                    }
                } else {
                    return {
                        top: itemPos.top + itemHeight,
                        left: itemPos.left,
                        right: 'auto'
                    }
                }
            }
        }
        hide() {
            const self = this;
            this.$item.removeClass('active');
            this.isShow = false;
            this.canHide = false;
            this.$sub.removeClass("show");
            this.hideTimer = setTimeout(function() {
                self.$sub.hide();
            }, 320);
        }
    };


    class ScrollHeader {
        constructor($header) {
            this.$page = $('#page');
            this.$header = $header;
            this.headerHeight = this.$header.outerHeight();
            this.isFixed = false;
            this.isShow = false;
            this.topBuffer = 80;
            this.needScrollSteps = 10;
            this.scrollDirectionSteps = 0;
            this.lastScrollTop = $(window).scrollTop();
            this.isFrozen = false;
            this.handle();
            this.check();
        }
        handle() {
            const self = this;
            $(window).on("scroll", function() {
                if(!self.isFrozen) {
                    self.check();
                    self.toggle();
                }
            });
        }
        check() {
            const self = this;
            const buffer = (self.headerHeight + self.topBuffer) * 2;
            if($(window).scrollTop() > buffer) {
                self.isFixed = true;
                //self.$page.css('padding-top', self.headerHeight);
                self.$header.addClass('fixed');
                $("#page").addClass('fixed');
                $(".main-menu-holder").removeClass("active");
            } else {
                //self.$page.css('padding-top', 0);
                self.isFixed = false;
                self.isShow = false;
                self.$header.removeClass('fixed show hide');
                $("#page").removeClass('fixed');
            }
        }
        toggle() {
            const st = $(window).scrollTop();
            if(st > this.lastScrollTop) {
                this.scrollDirectionSteps = 0;
            } else {
                this.scrollDirectionSteps++;
            }
            if(this.scrollDirectionSteps >= this.needScrollSteps) {
                this.scrollDirectionSteps = this.needScrollSteps;
                this.isShow = true;
                this.$header.addClass("show").removeClass('hide');
            } else {
                this.isShow = false;
                if(this.$header.hasClass('show')) {
                    this.$header.removeClass("show").addClass('hide');
                    $(".main-menu-holder").removeClass("active");
                }
            }
            this.lastScrollTop = st <= 0 ? 0 : st;
        }
        hold() {
            this.isFrozen = true;
            this.scrollDirectionSteps = 0;
            this.lastScrollTop = $(window).scrollTop();
        }
        release() {
            this.isFrozen = false;
            this.scrollDirectionSteps = 0;
            this.lastScrollTop = $(window).scrollTop();
        }
    }




    class BottomPopover {
        constructor($openBtn, $popover) {
            this.$openBtn = $openBtn;
            
            this.$popover = $popover;
            this.$popoverContents = this.$popover.find(".popover-contents");
            this.$popoverDraggableArea = this.$popover.find(".draggable-area");

            this.popoverContentHeight = this.$popoverContents.outerHeight();
            this.popoverControlsHeight = 50;
            this.popoverHeight = 0;
            this.dragPosition = 0;

            this.handle();
        }
        handle() {
            let self = this;

            this.$openBtn.on("click", () => {
                this.setSheetHeight();
                this.setIsSheetShown(true);
            });
            this.$popover.find(".popover-close, .popover-overlay").on("click", () => {
                this.setIsSheetShown(false);
            });
            this.$popoverDraggableArea.on("mousedown touchstart", self.onDragStart.bind(this));
            $(window).on("mousemove touchmove", self.onDragMove.bind(self));
            $(window).on("mouseup touchend", self.onDragEnd.bind(self));
        }
        setIsSheetShown(value) {
            //value ? bodyScrollLock.disableBodyScroll($("body")) : bodyScrollLock.enableBodyScroll($("body"));

            if(value)
            {
                $("body").css({overflow:"hidden"});
            }
            else
            {
                $("body").css({overflow:"auto"});
            }
            
            this.$popover.attr("aria-hidden", String(!value));
        }
        setSheetHeight(value = this.popoverContentHeight) {
            this.popoverHeight = Math.min(value, window.outerHeight - this.popoverControlsHeight);
            this.$popoverContents.css("height", this.popoverHeight);
        }
        touchPosition(event) {
            return event.touches ? event.touches[0] : event;
        }
        onDragStart(event) {
            this.dragPosition = this.touchPosition(event).pageY;
            this.$popoverContents.addClass("not-selectable");
        }  
        onDragMove(event) {
            if (this.dragPosition === undefined) {
                return false;
            }
            const y = this.touchPosition(event).pageY;
            const deltaY = this.dragPosition - y;
            const deltaHeight = deltaY / window.innerHeight * 100;
            
            //console.log(deltaY * 100, this.popoverContentHeight + deltaHeight);
            this.setSheetHeight(this.popoverHeight + deltaY);
            this.dragPosition = y;
        }
        onDragEnd() {
            this.dragPosition = undefined;
            this.$popoverContents.removeClass("not-selectable");
            
            if(this.popoverHeight < this.popoverContentHeight * 0.8) {
                this.setIsSheetShown(false);
            } else {
                this.setSheetHeight();
            }
        }
    }

       // Функция для получения куки
    function getCookie(name) {
        let matches = document.cookie.match(new RegExp(
            "(?:^|; )" + name.replace(/([.$?*|{}()[]\/+^])/g, '\\$1') + "=([^;]*)"
        ));
        return matches ? decodeURIComponent(matches[1]) : undefined;
    }

    // Функция для установки куки
    function setCookie(name, value, options = {}) {
        options = {
            path: '/',
            // при необходимости можно задать другие опции
            ...options
        };

        if (options.expires instanceof Date) {
            options.expires = options.expires.toUTCString();
        }

        let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(JSON.stringify(value));

        for (let optionKey in options) {
            updatedCookie += "; " + optionKey;
            let optionValue = options[optionKey];
            if (optionValue !== true) {
                updatedCookie += "=" + optionValue;
            }
        }

        document.cookie = updatedCookie;
    }


     var KEY = 'cookieConsent'; // 'all' | 'essential'

    function setConsent(val) {
        localStorage.setItem(KEY, JSON.stringify({ value: val, ts: Date.now() }));
        $('#cookie-popup').fadeOut(150);
        // здесь включайте/выключайте ваши аналитики
        // if (val === 'all') enableAnalytics();
        // else disableAnalytics();
    }

    function shouldShow() {
        try {
            var v = JSON.parse(localStorage.getItem(KEY) || 'null');
            return !v || !v.value;
        } catch (e) { return true; }
    }

    // публичный метод для повторного показа
    window.openCookiePopup = function () {
        $('#cookie-popup').fadeIn(150).attr('aria-hidden', 'false').attr('tabindex', '-1').focus();
    };

    
   if (shouldShow()) {
            window.openCookiePopup();
        }

        $('#ckp-accept-all').on('click', function () { setConsent('all'); });
        $('#ckp-accept-essential').on('click', function () { setConsent('essential'); });

        // Esc закрывает без выбора (можно убрать)
        $(document).on('keydown', function (e) {
            if (e.key === 'Escape') $('#cookie-popup').fadeOut(150);
        });

    
 

})(jQuery);
